import type {Module} from "vuex";
import type {RootState} from "@/store/types";
import {platform} from "@/api/platform";
import {retryRequest} from "@/helpers/request";
import orders from "./impersonation/orders"

export interface ImpersonatePayload {
    userId: string
    country?: string
}

export interface ImpersonationUserSearchItem {
    name: string
    email: string
}

const impersonation: Module<Record<string, never>, RootState> = {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        // Resolves with the impersonation token; a missing country (IMPERSONATE_USER_NO_COUNTRY) is not retried
        impersonate(context, {userId, country}: ImpersonatePayload): Promise<string> {

            return retryRequest(
                () => platform.post<{results: {token: string}}>(`/api/v2/users/${this.getters["user/id"]}/impersonate`, {
                    impersonate: userId,
                    country: country
                }),
                [1000, 2000],
                error => !('IMPERSONATE_USER_NO_COUNTRY' === error.response?.data?.meta?.error_code)
            ).then(response => response.data.results.token);
        },
        getUser(context, email: string) {

            return platform
                .get(`/api/v2/user`, {
                    params: {
                        email,
                        schema: "id,email,style_profile,allowed,properties,attributes".split(",")
                    }
                })
                .then(response => response.data.results);
        },
        createUser(context, request: Record<string, unknown>) {

            return retryRequest(() => platform.post("/api/v2/user/create", request))
                .then(response => response.data.results);
        },
        searchUser(context, query: string): Promise<ImpersonationUserSearchItem[]> {

            return platform
                .get<{results: ImpersonationUserSearchItem[]}>('/api/v2/user/search', {params: {query}})
                .then(response => response.data.results.map(item => ({
                    name: item.name,
                    email: item.email,
                })));
        }
    },
    modules: {
        orders
    }
}

export default impersonation
